import Skeleton from "react-loading-skeleton";

import "./styles.sass";

const SkeletonTopCategories = () => {
  return (
    <div className="SkeletonTopCategories">
      <Skeleton width="100%" height={80} count={4} inline />
    </div>
  );
};

export default SkeletonTopCategories;
